import { InjectionToken } from '@angular/core';
import { AnalyticsStrategy } from './analytics.model';

export const ANALYTICS_STRATEGIES = new InjectionToken<AnalyticsStrategy[]>(
  'ANALYTICS_STRATEGIES',
  {
    factory: () => []
  }
);

export const ANALYTICS_SCRIPTS = new InjectionToken<readonly (() => void)[]>('ANALYTICS_SCRIPTS');
